module.exports = __webpack_public_path__ + "img/results.a34edd50.svg";